import {FC} from "react";
import {useTranslation} from "react-i18next";
import {SelectInput} from "@interstate/components/SelectInput";

export interface BoidTypeSelectProps {
  id: string;
  value?: string;
  onChange: (event: any) => void;
  disabled?: boolean;
  label?: string;
}

const BOID_TYPES = [
  "AIS", "ATC", "DDC", "DT", "DMS", "ESN", "FDC", "FGC", "FNI", "FUS",
  "HMN", "ICO", "MAN", "MMD", "NGC", "VAT", "VIN", "XTI",
  "INTEGRATION_TEST", "ACTIVATION_TEST", "SMOKE_TEST", "TESTING"
];

export const BoidTypeSelect: FC<BoidTypeSelectProps> = ({
  id,
  value,
  onChange,
  disabled = false,
  label
}) => {
  const {t} = useTranslation();

  const options = BOID_TYPES.map(type => ({
    value: type,
    label: t(`entity-detail.business-operation-types.${type}`)
  }));

  return (
    <SelectInput
      id={id}
      data-testid={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
      label={label || t("entity-detail.boid-edit-table.select-boid-type", "BOID Type")}
      options={options}
      displayDeselectOption={false}
    />
  );
};
